/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import classnames from 'classnames';

import { StackConfig } from './useStackInfo';

export function SeriesControls<Data, Value>({
  stacks,
  toggleSeries,
  activeSeries,
  className,
  hideWhenSingleStack = false,
}: {
  stacks: StackConfig<Data, Value>[];
  toggleSeries: (index: number) => void;
  activeSeries: boolean[];
  className?: string;
  hideWhenSingleStack?: boolean;
}) {
  if (hideWhenSingleStack && stacks.length === 1) {
    return null;
  }

  return (
    <div className={classnames(className, 'inline-block')}>
      {stacks.map(({ label, primaryColor, legendColor }, i) => (
        <label
          key={label}
          className="relative inline-block cursor-pointer"
          css={css`
            margin: 0 30px 0 0;
            font-size: 12px;
            line-height: 16px;
            min-height: 1em;
          `}
        >
          <input
            className="invisible h-auto"
            css={css`
              margin-right: 0.7em;
            `}
            onChange={() => toggleSeries(i)}
            checked={activeSeries[i] ?? false}
            type="checkbox"
          />
          <span
            className="align-top"
            css={css`
              line-height: 14px;
            `}
          >
            <div
              className="absolute bottom-auto left-0 right-auto top-0 size-3.5"
              css={css`
                box-shadow: ${activeSeries[i]
                  ? `${legendColor ?? primaryColor} 0 0 0 1px inset`
                  : '#999 0 0 0 1px inset;'};
              `}
            />
            {label}
            <div
              className="absolute bottom-auto left-0 right-auto top-0 m-0.5 size-2.5 opacity-100"
              css={css`
                ${activeSeries[i]
                  ? `background: ${legendColor ?? primaryColor}`
                  : ''};
                transition: all 150ms ease-out;
                transform: scale3d(1, 1, 1);
              `}
            />
          </span>
        </label>
      ))}
    </div>
  );
}
